import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, Chip } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../theme";
import { engTemplateListAction } from "../../containers/engagement/action";
import { tokens, CHANNEL_COLORS } from "./utils";

const TRIGGER_LABELS = {
  PAYDAY_REMINDER: "Payday Reminder",
  FIRST_TX_NUDGE: "First Tx Nudge",
  MILESTONE_REWARD: "Milestone Reward",
  DORMANT_REACTIVATION: "Dormant Re-activation",
  NEW_FEATURE_ALERT: "New Feature Alert",
  CAMPAIGN_ANNOUNCEMENT: "Campaign Announcement",
  CUSTOM: "Custom",
};

const useStyles = makeStyles(() => ({
  header: {
    fontSize: 20,
    fontFamily: theme.fontFamily.MARKPROBOLD,
    color: theme.colors.DodgerBlue,
    marginBottom: 24,
  },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 },
  card: {
    background: tokens.surface,
    border: `1px solid ${tokens.border}`,
    borderRadius: 10,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: 10,
    transition: "box-shadow 0.15s",
    "&:hover": { boxShadow: "0px 2px 15px #D0CFDB55" },
  },
  cardName: { fontFamily: theme.fontFamily.MARKPROBOLD, color: theme.colors.DodgerBlue, fontSize: 15 },
  subject: { fontSize: 13, color: theme.colors.Violet, fontStyle: "italic", fontFamily: theme.fontFamily.MARKPRO },
  body: { fontSize: 12, color: tokens.textMuted, lineHeight: 1.5, fontFamily: theme.fontFamily.MARKPRO },
  chips: { display: "flex", gap: 6, flexWrap: "wrap" },
  chip: { fontSize: 11, fontFamily: theme.fontFamily.MARKPROMEDIUM, color: theme.colors.White },
  outlineChip: { fontSize: 11, fontFamily: theme.fontFamily.MARKPROMEDIUM, color: tokens.textMuted, borderColor: tokens.border },
  empty: { textAlign: "center", color: tokens.textSubtle, padding: "48px 0", fontFamily: theme.fontFamily.MARKPRO },
  spinnerRow: { display: "flex", justifyContent: "center", padding: "32px 0" },
}));

export default function TemplateLibrary() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { templates, loading } = useSelector((s) => s.engagementReducer);

  useEffect(() => {
    dispatch(engTemplateListAction({}));
  }, [dispatch]);

  return (
    <div>
      <div className={classes.header}>Notification Templates</div>

      {loading && templates.length === 0 && (
        <div className={classes.spinnerRow}>
          <CircularProgress size={28} style={{ color: theme.colors.DodgerBlue }} />
        </div>
      )}

      {!loading && templates.length === 0 && (
        <div className={classes.empty}>No templates found.</div>
      )}

      <div className={classes.grid}>
        {templates.map((t) => (
          <div key={t.id} className={classes.card}>
            <div className={classes.cardName}>{t.name}</div>
            <div className={classes.chips}>
              <Chip
                label={TRIGGER_LABELS[t.trigger] || t.trigger}
                size="small"
                className={classes.chip}
                style={{ backgroundColor: theme.colors.Violet }}
              />
              <Chip
                label={t.channel}
                size="small"
                className={classes.chip}
                style={{ backgroundColor: CHANNEL_COLORS[t.channel] || tokens.textMuted }}
              />
              {t.milestone_tx_count && (
                <Chip label={`At tx #${t.milestone_tx_count}`} size="small" variant="outlined" className={classes.outlineChip} />
              )}
            </div>
            <div className={classes.subject}>"{t.subject}"</div>
            <div className={classes.body}>{t.body}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
